<div class="signer-input" [class.advanced-options--active]="context === SignerInputContext.Default ? signer._extra.isLocked : context === SignerInputContext.Editor ? signer._extra.isEditable : ''">
  <div
    class="field__holder field__holder-small m-0"
    [class.error]="hasPhoneError && ['whatsapp', 'sms'].includes(signer._extra.signerMainAttribute) && signer[signer._extra.signerMainAttribute]"
    #signerTooltip="ngbTooltip"
    triggers="hover"
    [autoClose]="true"
    [ngbTooltip]="context === SignerInputContext.Default ? tipSigner : null"
    container="body"
    [placement]="tooltipPlacement"
  >
    @if (['email', 'name'].includes(signer._extra.signerMainAttribute)) {
      <input
        type="text"
        [name]="inputId"
        autocomplete="none"
        role="presentation"
        autocorrect="off"
        spellcheck="false"
        autocapitalize="off"
        class="field field__signer"
        [class.empty]="!signer[signer._extra.signerMainAttribute]"
        [(ngModel)]="signer[signer._extra.signerMainAttribute]"
        (ngModelChange)="modelChange(signer)"
        [appValidName]="signer._extra.signerMainAttribute === 'name'"
        [appValidEmail]="signer._extra.signerMainAttribute === 'email'"
        #inputModel="ngModel"
        #inputElement
        (focus)="signerTooltip ? signerTooltip.toggle() : null"
        [id]="inputId"
        [disabled]="isEditOptionsDisabled"
      />
    }
    @if (['whatsapp', 'sms'].includes(signer._extra.signerMainAttribute)) {
      <app-phone-number
        [id]="inputId"
        (focus)="signerTooltip ? signerTooltip.toggle() : null"
        inputClass="field field__signer"
        [(ngModel)]="signer[signer._extra.signerMainAttribute]"
        (ngModelChange)="modelChange(signer)"
        (validationError)="hasPhoneError = $event"
        name="phone"
        autocomplete="tel-national"
        #phoneInputModel="ngModel"
        [appDisableInput]="isEditOptionsDisabled"
      ></app-phone-number>
      <small [hidden]="!hasPhoneError || !signer[signer._extra.signerMainAttribute]" class="text-danger">{{ 'error_invalid_phone_number' | translate }}</small>
    }
    @if (['sms'].includes(signer._extra.signerMainAttribute) && appService.creditPriceByType(CreditTypeEnum.DeliveryMethodSms) > 0) {
      <div class="credits__content credits__content--inner-field credits__content--inner-field-sms">
        <i class="fal fa-shield-check"></i>{{ appService.creditPriceByType(CreditTypeEnum.DeliveryMethodSms) }}
      </div>
    }
    @if (['whatsapp'].includes(signer._extra.signerMainAttribute) && appService.creditPriceByType(CreditTypeEnum.DeliveryMethodWhatsapp) > 0) {
      <div class="credits__content credits__content--inner-field credits__content--inner-field-whatsapp">
        <i class="fal fa-shield-check"></i>{{ appService.creditPriceByType(CreditTypeEnum.DeliveryMethodWhatsapp) }}
      </div>
    }
    <label class="field__placeholder" [class.desculpa]="['whatsapp', 'sms'].includes(signer._extra.signerMainAttribute)" [for]="inputId">
      {{ getInputPlaceholder() }}
    </label>

    <div class="signer-field-option" ngbDropdown placement="bottom-right">
      @if (isEditOptionsDisabled) {
        @if (context !== SignerInputContext.Editor) {
          <span class="signer-field-option-title" [class.with-caret]="!isEditOptionsDisabled" [ngbTooltip]="tipSignerType" container="body" placement="top">{{
            'signer_attr_abbr_' + signer._extra.signerMainAttribute | lowercase | translate
          }}</span>
        }
      } @else {
        <span class="signer-field-option-title" [class.with-caret]="!isEditOptionsDisabled" ngbDropdownToggle [ngbTooltip]="tipSignerType" container="body" placement="top">{{
          'signer_attr_abbr_' + signer._extra.signerMainAttribute | lowercase | translate
        }}</span>
        <div ngbDropdownMenu>
          @for (attr of signerMainAttributesValues; track $index) {
            @if (!['phone'].includes(attr)) {
              <button type="button" ngbDropdownItem class="d-flex" (click)="changeSignerMainAttribute(signer, attr)">
                <div class="signer-field-option-fal">
                  @switch (attr) {
                    @case ('email') {
                      <i class="far fa-envelope"></i>
                    }
                    @case ('name') {
                      <i class="far fa-link"></i>
                    }
                    @case ('sms') {
                      <i class="far fa-comment-alt"></i>
                    }
                    @case ('whatsapp') {
                      <i class="fab fa-whatsapp"></i>
                    }
                  }
                </div>

                {{ 'signature.signerAttr.' + (attr | lowercase) | translate }}

                @if (attr === 'sms' && appService.creditPriceByType(CreditTypeEnum.DeliveryMethodSms) > 0) {
                  <div class="credits__content" [ngbTooltip]="infoCreditsTooltip" container="body" [placement]="tooltipPlacement">
                    <i class="fal fa-shield-check"></i>{{ appService.creditPriceByType(CreditTypeEnum.DeliveryMethodSms) }}
                  </div>
                }
                @if (attr === 'whatsapp' && appService.creditPriceByType(CreditTypeEnum.DeliveryMethodWhatsapp) > 0) {
                  <div class="credits__content" [ngbTooltip]="infoCreditsTooltip" container="body" [placement]="tooltipPlacement">
                    <i class="fal fa-shield-check"></i>{{ appService.creditPriceByType(CreditTypeEnum.DeliveryMethodWhatsapp) }}
                  </div>
                }
              </button>
            }
          }
        </div>
      }
    </div>
  </div>

  @if (signerIndex > 0 && context === SignerInputContext.Editor) {
    <button class="delete_signer btn-XS btn-filled icon-only" (click)="removeSigner.emit(signerIndex)">
      <i class="fal fa-xmark"></i>
    </button>
  }

  <div class="signer-options">
    <div class="signer-options-role" ngbDropdown>
      <span class="signer-options-role-text">{{ 'documents.role' | translate }}</span>
      @if (context !== SignerInputContext.NewDynamicDocument || !isEditOptionsDisabled) {
        <span class="signer-options-role-current with-caret" ngbDropdownToggle>{{ 'sign_action_' + (signer.action || 'none') | lowercase | translate }}</span>
        <div ngbDropdownMenu>
          @for (role of documentService.roles; track $index) {
            <button type="button" (click)="signer.action = role; changeSigner.emit(signer)" ngbDropdownItem>
              {{ 'signature.signAction.' + (role | lowercase) | translate }}
            </button>
          }
          @if (context === SignerInputContext.Editor && signerIndex === 0) {
            <button type="button" (click)="signer.action = null; changeSigner.emit(signer)" ngbDropdownItem>
              {{ 'signature.signAction.none' | translate }}
            </button>
          }
        </div>
      } @else {
        <span class="signer-options-role-current">{{ 'sign_action_' + signer.action | lowercase | translate }}</span>
      }
    </div>
    <ng-content></ng-content>
    @if (signerIndex !== 0 && ![SignerInputContext.NewDynamicDocument, SignerInputContext.CreateSigner].includes(context)) {
      <div
        class="signer-options-advanced-option"
        container="body"
        placement="top"
        [class.active]="context === SignerInputContext.Default ? signer._extra.isLocked : signer._extra.isEditable"
        [ngbTooltip]="tipSignerMemo"
        (click)="changeSignerAdvancedOption()"
      >
        <i class="fa-regular" [ngClass]="(context === SignerInputContext.Default ? signer._extra.isLocked : signer._extra.isEditable) ? 'fa-lock' : 'fa-lock-open'"></i>
      </div>
    }
    @if (!qualified || isCountryBR) {
      <div class="signer-options-advanced" [class.d-none]="signerIndex === 0 && signer.action === null">
        <div class="signer-options-advanced-validation" (click)="signer._extra.showOptions = !signer._extra.showOptions">
          @if (signer._extra.showOptions) {
            <span>{{ 'documents.lessOptions' | translate }} <i class="fal fa-minus"></i></span>
          } @else {
            <span>{{ 'documents.moreOptions' | translate }} <i class="fal fa-plus"></i></span>
          }
        </div>
      </div>
    }
    @if (currentUser && signer._extra.showOptions && (!qualified || isCountryBR)) {
      <div class="validation">
        <div class="validation__list">
          @if (shouldShowQualifiedOption()) {
            <div class="validation__list-option">
              <!-- TODO remove style.cursor when has_corporate_features is added for real -->
              <div
                class="validation__checkbox"
                [class.disabled]="!currentUser.subscription?.has_corporate_features"
                [style.cursor]="!currentUser.subscription?.has_corporate_features ? 'not-allowed' : 'pointer'"
                [ngbTooltip]="signerQualifiedTooltip"
                container="body"
                [placement]="tooltipPlacement"
              >
                <input
                  type="checkbox"
                  class="checkbox__field"
                  (ngModelChange)="onSignerQualifiedChange()"
                  [(ngModel)]="signer._extra.isQualified"
                  [id]="'sigQualified-' + inputId"
                  [disabled]="!currentUser.subscription?.has_corporate_features"
                />
                <label class="checkbox__label" [for]="'sigQualified-' + inputId" [style.cursor]="!currentUser.subscription?.has_corporate_features ? 'not-allowed' : 'pointer'"></label>
                <label
                  class="checkbox__label-text pro"
                  [for]="'sigQualified-' + inputId"
                  [style.cursor]="!currentUser.subscription?.has_corporate_features ? 'not-allowed' : 'pointer'"
                  [attr.data-pro-text]="translateService.instant('shared.corporate')"
                >
                  {{ 'documents.signatureQualified' | translate }}
                </label>
              </div>
            </div>
          }
          @if (!qualified && isCountryBR && ['email', 'name'].includes(signer._extra.signerMainAttribute)) {
            <div class="validation__list-option">
              <div
                class="validation__checkbox"
                (pointerdown)="userService.checkPremiumFeatures($event, currentUser)"
                [ngbTooltip]="verificationSmsTooltip"
                container="body"
                [placement]="tooltipPlacement"
              >
                <input
                  type="checkbox"
                  class="checkbox__field"
                  [disabled]="!currentUser.subscription?.has_premium_features || signer._extra.isQualified"
                  (ngModelChange)="changeSigner.emit(signer)"
                  [(ngModel)]="signer._extra.showSmsVerification"
                  [id]="'sms-' + inputId"
                />
                <label class="checkbox__label" [for]="'sms-' + inputId"></label>
                <label class="checkbox__label-text pro" [for]="'sms-' + inputId" [attr.data-pro-text]="translateService.instant('shared.pro')">
                  {{ 'documents.requireSMSValidation' | translate }}
                </label>
              </div>
              @if (signer._extra.showSmsVerification) {
                <div class="field__holder field__holder-small" [class.error]="signer._extra.phoneNumber && hasVerificationPhoneError">
                  <app-phone-number
                    inputClass="field"
                    name="phoneNumber"
                    [(ngModel)]="signer._extra.phoneNumber"
                    (ngModelChange)="changeSigner.emit(signer)"
                    (validationError)="hasVerificationPhoneError = $event"
                    autocomplete="tel-national"
                  ></app-phone-number>
                  <small [hidden]="!signer._extra.phoneNumber || !hasVerificationPhoneError" class="text-danger">{{ 'error_invalid_phone_number' | translate }}</small>
                  <label class="field__placeholder focus">{{ 'documents.signatoryPhoneNumber' | translate }}</label>
                  @if (appService.creditPriceByType(CreditTypeEnum.SecurityVerificationSms) > 0) {
                    <div class="credits__content input" [ngbTooltip]="infoCreditsTooltip" container="body" [placement]="tooltipPlacement">
                      <i class="fal fa-shield-check"></i> {{ appService.creditPriceByType(CreditTypeEnum.SecurityVerificationSms) }}
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (!qualified && (!isMarkdown || signer._extra.signerMainAttribute !== SignerMainAttributes.Whatsapp)) {
            <div class="validation__list-option">
              <div class="validation__checkbox" [ngbTooltip]="verificationTypesTooltip" container="body" [placement]="tooltipPlacement">
                <input
                  type="checkbox"
                  class="checkbox__field"
                  (ngModelChange)="changeSigner.emit(signer)"
                  [disabled]="signer._extra.isQualified"
                  [(ngModel)]="signer._extra.showSecurityVerifications"
                  [id]="'sv-' + inputId"
                />
                <label class="checkbox__label" [for]="'sv-' + inputId"></label>
                <label class="checkbox__label-text" [for]="'sv-' + inputId">
                  {{ 'documents.requirePhotoIDDocument' | translate }}
                </label>
              </div>
              @if (signer._extra.showSecurityVerifications) {
                <div class="field__holder field__holder-small">
                  <app-select
                    [(ngModel)]="signer._extra.documentType"
                    placeholder="{{ 'appSelect.validationType' | translate }}"
                    (ngModelChange)="changeSigner.emit(signer)"
                    [disableSearch]="true"
                    [useSelectionMarginOverride]="true"
                    [options]="[
                      {
                        key: SecurityVerificationEnum.Manual,
                        value: 'appSelect.manualApproval' | translate,
                        tooltip: verificationManualTooltip,
                        tooltipPlacement,
                        height: 44,
                        fontSize: 16,
                        credits: appService.creditPriceByType(CreditTypeEnum.SecurityVerificationManual)
                      },
                      {
                        key: SecurityVerificationEnum.Upload,
                        value: 'appSelect.photoIDDocumentValidation' | translate,
                        tooltip: verificationUploadTooltip,
                        tooltipPlacement,
                        height: 44,
                        fontSize: 16,
                        credits: appService.creditPriceByType(CreditTypeEnum.SecurityVerificationUpload)
                      },
                      {
                        key: SecurityVerificationEnum.Live,
                        value: 'appSelect.IDDocumentSelfieProofValidation' | translate,
                        tooltip: verificationLiveTooltip,
                        tooltipPlacement,
                        height: 44,
                        fontSize: 16,
                        credits: appService.creditPriceByType(CreditTypeEnum.SecurityVerificationLive)
                      },
                      {
                        key: SecurityVerificationEnum.PfFacial,
                        value: 'appSelect.SERPROBiometricsValidation' | translate,
                        tooltip: verificationPfFacialTooltip,
                        tooltipPlacement,
                        height: 44,
                        fontSize: 16,
                        credits: appService.creditPriceByType(CreditTypeEnum.SecurityVerificationPfFacial),
                        hidden: !isCountryBR
                      },
                      {
                        key: SecurityVerificationEnum.BiometricAndTextExtraction,
                        value: 'appSelect.BiometricAndTextExtraction' | translate,
                        tooltip: verificationBiometricAndTextExtractionTooltip,
                        tooltipPlacement,
                        height: 44,
                        fontSize: 16,
                        credits: appService.creditPriceByType(CreditTypeEnum.SecurityVerificationBiometricAndTextExtraction),
                        flag: 'beta'
                      },
                      {
                        key: SecurityVerificationEnum.LivenessAndTextExtraction,
                        value: 'appSelect.LivenessAndTextExtraction' | translate,
                        tooltip: verificationSecurityVerificationBiometricAndTextExtractionTooltip,
                        tooltipPlacement,
                        height: 44,
                        fontSize: 16,
                        credits: appService.creditPriceByType(CreditTypeEnum.SecurityVerificationLivenessAndTextExtraction),
                        flag: 'beta'
                      },
                      {
                        key: SecurityVerificationEnum.PfFacialMatch,
                        value: 'appSelect.PfFacialMatch' | translate,
                        tooltip: verificationPfFacialMatchTooltip,
                        tooltipPlacement,
                        height: 44,
                        fontSize: 16,
                        credits: appService.creditPriceByType(CreditTypeEnum.SecurityVerificationLivenessAndTextExtraction),
                        flag: 'beta',
                        hidden: hidePfFacialMatch()
                      }
                    ]"
                  >
                  </app-select>
                </div>
              }
              @if (signer._extra.showSecurityVerifications && signer._extra.documentType !== SecurityVerificationEnum.Manual) {
                <div class="validation__checkbox mt-2 ml-3" [ngbTooltip]="biometricManualFallbackTooltip" container="body" [placement]="tooltipPlacement">
                  <input type="checkbox" class="checkbox__field" (ngModelChange)="changeSigner.emit(signer)" [(ngModel)]="signer._extra.fallbackEnabled" [id]="'mf-' + inputId" />
                  <label class="checkbox__label" [for]="'mf-' + inputId"></label>
                  <label class="checkbox__label-text" [for]="'mf-' + inputId">
                    {{ 'documents.manualFallbackEnabled' | translate }}
                  </label>
                </div>
              }
            </div>
          }
          @if (isCountryBR) {
            <div class="validation__list-option">
              <div
                class="validation__checkbox"
                (pointerdown)="userService.checkPremiumFeatures($event, currentUser)"
                [ngbTooltip]="qualified || signer._extra.isQualified ? tipSignerCpfCnpj : tipSignerCpf"
                container="body"
                [placement]="tooltipPlacement"
              >
                <input
                  type="checkbox"
                  class="checkbox__field"
                  [disabled]="!currentUser.subscription?.has_premium_features"
                  (ngModelChange)="changeSigner.emit(signer)"
                  [(ngModel)]="signer._extra.showCpfVerification"
                  [id]="'cpf-' + inputId"
                />
                <label class="checkbox__label" [for]="'cpf-' + inputId"></label>
                <label class="checkbox__label-text pro" [for]="'cpf-' + inputId" [attr.data-pro-text]="translateService.instant('shared.pro')">{{
                  'documents.' + (qualified || signer._extra.isQualified ? 'setSignatoryCPForCNPJ' : 'setSignatoryCPF') | translate
                }}</label>
              </div>
              @if (signer._extra.showCpfVerification) {
                <div class="field__holder field__holder-small">
                  <app-cpf-cnpj-input
                    inputClass="field"
                    [(ngModel)]="cpfCnpj"
                    [cpfOnly]="!qualified && !signer._extra.isQualified"
                    (ngModelChange)="onCpfCnpjChange(signer)"
                    [label]="('profile.cpf' | translate) + (qualified || signer._extra.isQualified ? ' / ' + ('profile.cnpj' | translate) : '')"
                    [hasError]="!!(validationErrors?.configs?.cpf || validationErrors?.configs?.cnpj)"
                    tabindex="-1"
                  ></app-cpf-cnpj-input>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>

  <div class="suggestion" [class.suggestion--open]="contacts.length > 0" #suggestions>
    <div class="suggestion__gap"></div>
    <div class="suggestion__item-list">
      @for (contact of contacts; track $index) {
        <a href="javascript:void(0)" class="suggestion__item" (click)="selectContact(contact)">
          <div class="suggestion__item-name" [innerHTML]="contact.name | highlight: signer[signer._extra.signerMainAttribute]"></div>
          @if (getContactDetail(contact, signer)) {
            <div class="suggestion__item-email" [innerHTML]="getContactDetail(contact, signer) | highlight: signer[signer._extra.signerMainAttribute]"></div>
          }
        </a>
      }
    </div>
  </div>
</div>

<ng-template #tipSigner>
  <div class="tooltip__title">{{ 'documents.signatories' | translate }}</div>
  <div class="tooltip__descr">{{ 'documents.peopleSigning' | translate }}</div>
</ng-template>
<ng-template #tipSignerType>
  <div class="tooltip__tip">{{ 'documents.deliveryType' | translate }}</div>
</ng-template>
<ng-template #tipSignerMemo>
  <div class="tooltip__tip">{{ 'documents.remember' | translate }}</div>
</ng-template>
<ng-template #tipSignerCpf>
  <div class="tooltip__title">{{ 'documents.setSignatoryCPF' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.signatoryCPFValidation' | translate }}
  </div>
</ng-template>
<ng-template #tipSignerCpfCnpj>
  <div class="tooltip__title">{{ 'documents.setSignatoryCPForCNPJ' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.signatoryCPFCnpjValidation' | translate }}
  </div>
</ng-template>
<ng-template #infoCreditsTooltip>
  <div class="tooltip__title">{{ 'documents.additionalValidationCredit' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.someProceduresCostMore' | translate }}
  </div>
</ng-template>
<ng-template #verificationSmsTooltip>
  <div class="tooltip__title">{{ 'documents.requireSMSValidation' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.validatePhoneNumber' | translate }}
  </div>
</ng-template>
<ng-template #verificationTypesTooltip>
  <div class="tooltip__title">{{ 'documents.requireIDDocument' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.attachIDAndProof' | translate }}
  </div>
</ng-template>
<ng-template #verificationManualTooltip>
  <div class="tooltip__title">{{ 'documents.manualApproval' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.manualApprovalDescr' | translate }}
  </div>
</ng-template>
<ng-template #verificationUploadTooltip>
  <div class="tooltip__title">{{ 'documents.photoIDDocument' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.attachPhotoIDDocument' | translate }}
  </div>
</ng-template>
<ng-template #verificationLiveTooltip>
  <div class="tooltip__title">{{ 'documents.photoIDDocumentSelfieProof' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.attachIDSelfieProof' | translate }}
  </div>
</ng-template>
<ng-template #verificationPfFacialTooltip>
  <div class="tooltip__title">{{ 'documents.SERPROBiometrics' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.takeSelfieSERPRO' | translate }}
  </div>
</ng-template>
<ng-template #verificationBiometricAndTextExtractionTooltip>
  <div class="tooltip__title">{{ 'appSelect.BiometricAndTextExtraction' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.biometricAndTextExtractionDesc' | translate }}
  </div>
</ng-template>
<ng-template #biometricManualFallbackTooltip>
  <div class="tooltip__title">{{ 'documents.biometricManualFallbackTitle' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.biometricManualFallbackDesc' | translate }}
  </div>
</ng-template>
<ng-template #verificationBiometricAndTextExtractionTooltip>
  <div class="tooltip__title">{{ 'appSelect.BiometricAndTextExtraction' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.biometricAndTextExtractionDesc' | translate }}
  </div>
</ng-template>
<ng-template #verificationSecurityVerificationBiometricAndTextExtractionTooltip>
  <div class="tooltip__title">{{ 'appSelect.LivenessAndTextExtraction' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.livenessAndTextExtractionDesc' | translate }}
  </div>
</ng-template>
<ng-template #signerQualifiedTooltip>
  <div class="tooltip__title">{{ 'documents.signatureQualified' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.signerQualifiedDesc' | translate }}
  </div>
</ng-template>
<ng-template #verificationPfFacialMatchTooltip>
  <div class="tooltip__title">{{ 'documents.pfFacialMatch' | translate }}</div>
  <div class="tooltip__descr">
    {{ 'documents.pfFacialMatchDesc' | translate }}
  </div>
</ng-template>
